export default __webpack_public_path__ + "static/mirai-magical-school-winter-festival_24-9848e50dee7930bb888516594961f3c2.png";